$(document).ready(function(e){
	if ($(document).find('#KiwisaverWithdrawalForm').length > 0){

        $(document).find('.toggle-show-at-first').click(function(){
            $(document).find('.show-at-first').fadeOut(100);
            // Scroll the browser to the page top
			var scrollDiv = document.getElementById('KiwisaverWithdrawalForm').offsetTop;
			window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
        });

    }
});